import { localEnvironment } from './environment.local';

const supabaseConfig = localEnvironment as typeof localEnvironment & {
  supabaseUrl?: string;
  supabasePublishableKey?: string;
};

export const environment = {
  production: false,
  // Default OpenAI-compatible endpoint. It may include the `/v1` segment.
  rootUrl: 'https://api.openai.com/v1/',
  // LM Studio is still proxied when this local URL is selected in Settings.
  lmStudioRootUrl: 'http://127.0.0.1:1234/',
  // Browser-facing URL for the local LM Studio server.
  apiUrl: '/api/lm-studio',
  // Optional bearer token for an OpenAI-compatible provider, supplied locally.
  apiKey: localEnvironment.apiKey,
  // Public Supabase client configuration. Database access is constrained by RLS.
  supabaseUrl: supabaseConfig.supabaseUrl ?? '',
  supabasePublishableKey: supabaseConfig.supabasePublishableKey ?? '',
  // A broadly available Chat Completions model; Settings can override this.
  llmModel: 'gpt-4.1-mini',
  // Same-origin proxies in development keep external search requests CORS-safe.
  webSearchUrl: '/api/web-search/',
  webInstantAnswerUrl: '/api/web-answer/'
};
